import { render, staticRenderFns } from "./TableOrderStatisticsPage.vue?vue&type=template&id=abfa054c&scoped=true&"
import script from "./TableOrderStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./TableOrderStatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./TableOrderStatisticsPage.vue?vue&type=style&index=0&id=abfa054c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfa054c",
  null
  
)

export default component.exports